import styled from 'styled-components/macro';

import { H1 } from 'features/common/components/headings';
import { breakpoints, color } from 'features/common/constants';
import {
  rem,
  SelectInput as TempoSelectInput,
  SelectInputProps,
  textSize,
  textWeight,
} from '@nowsta/ux-common-components';
import { fade } from 'features/common/utils';
import { Link } from 'react-router-dom';

export const Header = styled(H1)`
  margin-top: 1.3rem;
  margin-bottom: 1.48rem;
`;

export const DeparmentsHolder = styled.div`
  display: flex;
  gap: ${rem(8)};
`;

export const ButtonsHolder = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin: 23px 0;
  justify-content: space-between;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const ActionsHolder = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Row = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: ${rem(32)} 0 0 0;

  svg.icon {
    fill: ${color.slateDark};
  }
`;

export const OnQueue = styled.div`
  font-style: normal;
  font-weight: ${textWeight.medium};
  color: ${color.slate};
  font-size: ${rem(12)};
  line-height: ${rem(18)};
  display: flex;
  align-items: center;

  svg {
    margin-right: 6px;
  }
`;

export const GeneratingCSV = styled.div`
  font-style: normal;
  font-weight: ${textWeight.medium};
  color: ${color.pink};
  font-size: ${rem(12)};
  line-height: ${rem(18)};
  display: flex;
  align-items: center;

  span {
    margin-right: 6px;
  }
`;

export const Table = styled.table`
  margin-top: 40px;
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;

  thead {
    tr {
      background: ${color.slateDarker};
      font-family: 'Silka';
      font-style: normal;
      font-weight: ${textWeight.semiBold};
      font-size: ${rem(14)};
      line-height: ${rem(18)};
      text-align: right;
      color: white;
      height: 48px;

      th {
        padding: 0 24px;

        background: ${color.slateDarker};
        text-align: left;
        max-width: 100px;
        font-style: normal;
        font-weight: ${textWeight.regular};
        font-size: ${rem(12)};
        line-height: ${rem(14)};
        left: 0;
        z-index: 1;
        border-right: 0;
      }
    }
  }

  tbody {
    tr {
      height: 40px;
      background: #ffffff;
      border-bottom: 1px solid ${color.pattensBlue};

      td {
        padding: 0 24px;
        font-family: 'Silka';
        font-style: normal;
        font-weight: ${textWeight.regular};
        font-size: 14px;
        line-height: 18px;
        text-align: right;
        color: ${color.slateDarker};
        text-align: left;

        &:first-child {
          font-weight: ${textWeight.semiBold};
          ${textSize.f14};
          background-color: white;
        }
      }
    }
  }
`;

export const SelectInput = styled(TempoSelectInput)<SelectInputProps>`
  select {
    ${({ value }) =>
      !value &&
      `
        color: ${fade(color.slateDarker, 30)};
      `}
  }
`;

export const NewInvoicePageLink = styled(Link)`
  color: ${color.slateDark};
  font-weight: ${textWeight.semiBold};
`;
